import { useEffect, useState } from "react";

import { apiRoot } from "../constants";

const useLocations = () => {
  const [cities, setCities] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    fetch(`${apiRoot}/cities/`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setCities(json);
            setError(false);
            setLoading(false);

          });
        } else {
          setError(true);
          setCities([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setCities([]);
        setLoading(false);
      });
  }, []);

  return {
    cities,
    error,
    loading,
  };
};

export default useLocations;
